"use strict";

import angular from "angular";

angular.module("nucont.accounting.customVariablesIndicatorsCharts", [
    "nucont.shared"
]);
require("./custom-variables-indicators-chart.routes");
